<template>
	<transition name="loading-fade">
		<div v-if="visible" class="loading-overlay">
			<div class="loading-overlay__container">
				<div class="loading-overlay__spinner">
					<img src="/m.eagle/img/logo-transparent-unmarged-2026.png" class="loading-overlay__logo" alt="" />
					<div class="loading-overlay__ring">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
				<span v-if="message" class="loading-overlay__label">{{ message }}</span>
			</div>
		</div>
	</transition>
</template>

<script setup>
defineProps({
	visible: {
		type: Boolean,
		default: false,
	},
	message: {
		type: String,
		default: '',
	},
});
</script>

<style scoped>
.loading-overlay {
	position: fixed;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(var(--v-theme-surface), 0.92);
	z-index: 9999;
}

.loading-overlay__container {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
}

.loading-overlay__spinner {
	position: relative;
	width: 175px;
	height: 175px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.loading-overlay__logo {
	position: absolute;
	width: 150px;
	height: 150px;
	object-fit: contain;
}

.loading-overlay__ring {
	position: absolute;
	inset: 0;
}

.loading-overlay__ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 100%;
	height: 100%;
	border: 10px solid transparent;
	border-top-color: rgb(0 21 69);
	border-radius: 50%;
	animation: loading-ring-spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.loading-overlay__ring div:nth-child(1) {
	animation-delay: -0.45s;
}
.loading-overlay__ring div:nth-child(2) {
	animation-delay: -0.3s;
}
.loading-overlay__ring div:nth-child(3) {
	animation-delay: -0.15s;
}

.loading-overlay__label {
	font-size: 0.875rem;
	color: rgb(var(--v-theme-on-surface));
	opacity: 0.65;
}

.loading-fade-enter-active,
.loading-fade-leave-active {
	transition: opacity 0.2s ease;
}

.loading-fade-enter-from,
.loading-fade-leave-to {
	opacity: 0;
}

@keyframes loading-ring-spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
